import useGeo from '~/src/hooks/useGeo'

const useIsSupportedCountries = (countries: String[]) => {
  const { data: geoData, isLoading } = useGeo()
  const country: string = (geoData?.country || '').toLowerCase()

  const isInSupportedCountry =
    countries.includes(country) || process.env.NODE_ENV === 'development'

  return {
    country,
    isLoading,
    isInSupportedCountry,
  }
}

export default useIsSupportedCountries
